import { render } from "./Base_Display.vue?vue&type=template&id=0fad5805&scoped=true"
import script from "./Base_Display.vue?vue&type=script&lang=js"
export * from "./Base_Display.vue?vue&type=script&lang=js"

import "./Base_Display.vue?vue&type=style&index=0&id=0fad5805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fad5805"]])

export default __exports__